import { Box } from '@dropbox/dig-foundations';
import React, { useEffect, useState } from 'react';
import styles from 'signer-app/parts/loader/dot-loader.module.css';
import classnames from 'classnames';
import whiteLabelStyles from 'signer-app/white-labeling/theme-provider.module.css';
import { WhiteLabelThemeProvider } from 'signer-app/white-labeling/theme-provider';

const numCircles = 5;
const radius = 10;
const gap = 10;
const diameter = radius * 2;
const margin = 2;
const totalWidth = diameter * numCircles + gap * (numCircles - 1) + margin * 2;
const totalHeight = diameter + margin * 2;

export function DotLoader() {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((i) => (i + 1) % numCircles);
    }, 500);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <svg
      width="100%"
      viewBox={`0 0 ${totalWidth} ${totalHeight}`}
      version="1.1"
      role="presentation"
    >
      <g>
        {Array.from({ length: numCircles }).map((_, i) => (
          <circle
            key={i}
            data-state={activeIndex === i ? 'active' : 'idle'}
            cx={(diameter + gap) * i + radius + margin}
            r={radius}
            cy={radius + margin}
            className={styles.circle}
          />
        ))}
      </g>
    </svg>
  );
}

export function FullPageDotLoader({
  children,
}: {
  children?: React.ReactNode;
}) {
  return (
    <WhiteLabelThemeProvider mode="bright">
      <Box
        className={classnames(
          styles.fullPageLoader,
          whiteLabelStyles.loaderBackground,
        )}
      >
        <DotLoader />
        {children}
      </Box>
    </WhiteLabelThemeProvider>
  );
}
